import React from 'react'


class Nav extends React.Component {
    render(){
        const { destination, className } = this.props;

        if (destination === true) {
            return (
                <nav className={`main-nav ${className}`}>
                    <ul className="main-nav_list">
                        <li className="main-nav_item"><a className="main-nav_link" href="../#speakers">Speakers</a></li>
                        <li className="main-nav_item"><a className="main-nav_link" href="../#schedule">Schedule</a></li>
                        <li className="main-nav_item"><a className="main-nav_link" href="../#tickets">Tickets</a></li>
                        <li className="main-nav_item"><a className="main-nav_link" href="../#venue">Venue</a></li>
                        <li className="main-nav_item"><a className="main-nav_link" href="../#sponsors">Sponsors</a></li>
                        <li className="main-nav_item"><a className="main-nav_link" href="../code-of-conduct">Code of Conduct</a></li>
                        <li className="main-nav_item"><a className="main-nav_link" href="../#team">Team</a></li>
                    </ul>
                </nav>
            )
            } else {
                return (
                    <nav className={`main-nav ${className}`}>
                        <ul className="main-nav_list">
                            <li className="main-nav_item"><a className="main-nav_link" href="#speakers">Speakers</a></li>
                            <li className="main-nav_item"><a className="main-nav_link" href="#schedule">Schedule</a></li>
                            <li className="main-nav_item"><a className="main-nav_link" href="#tickets">Tickets</a></li>
                            <li className="main-nav_item"><a className="main-nav_link" href="#venue">Venue</a></li>
                            <li className="main-nav_item"><a className="main-nav_link" href="#sponsors">Sponsors</a></li>
                            <li className="main-nav_item"><a className="main-nav_link" href="code-of-conduct">Code of Conduct</a></li>
                            <li className="main-nav_item"><a className="main-nav_link" href="#team">Team</a></li>
                        </ul>
                    </nav>
                )
            }
        }
    }

Nav.defaultProps = {
    className: ""
}

export default Nav



// WEBPACK FOOTER //
// ./src/components/Nav/index.js